{
  "contactCustomerService": "Liên hệ bộ phận hỗ trợ",
  "close": "Đóng",
  "notConfigured": "Chưa thiết lập bộ phận hỗ trợ",
  "temporarilyUnavailable": "Tạm thời không thể tải bộ phận hỗ trợ",
  "retry": "Thử lại"
}
